module.exports = __webpack_public_path__ + "img/index-banner-bg.0f90ded0.png";